function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 0.0 466.5 466.5",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(38, 227, 186)"
    },
    original_string_length: 503,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "sparkle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.463,233.231c-174.924,32.203-201.029,58.308-233.231,233.231C201.029,291.539,174.924,265.434,0,233.231 C174.924,201.029,201.029,174.924,233.231,0C265.434,174.924,291.539,201.029,466.463,233.231z",
    style: {
      fill: "inherit"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/Sparkle.c6c896398f49ce997e1a3ac21bccf66f.svg";
export { ForwardRef as ReactComponent };